import type { IDocument } from '../models';

/** Возвращает контент или пустую строку */
export const getDocument = (documents: IDocument[], id: number) =>
    documents.find(doc => doc.id === id)?.content || '';
